export var TableControlFetchMode;
(function (TableControlFetchMode) {
  TableControlFetchMode["Client"] = "client";
  TableControlFetchMode["Server"] = "server";
})(TableControlFetchMode || (TableControlFetchMode = {}));
// sourceMappingURL=TableControlLayoutProps.js.map
